import React, { type ReactNode } from "react";

interface SectionTileProps {
  icon: ReactNode;
  title: string;
  description: string;
  onClick: () => void;
}

const SectionTile: React.FC<SectionTileProps> = ({ icon, title, description, onClick }) => (
  <button
    type="button"
    className="group relative flex min-h-[200px] overflow-hidden flex-col items-center justify-center gap-3 rounded-[24px] border border-slate-200/80 bg-white/95 p-6 text-center shadow-[0_14px_35px_rgba(15,23,42,0.08)] transition hover:-translate-y-0.5 hover:border-indigo-200 hover:shadow-[0_20px_45px_rgba(15,23,42,0.12)] focus:outline-none focus:ring-2 focus:ring-indigo-500 motion-reduce:transform-none motion-reduce:transition-none dark:border-white/10 dark:bg-slate-950/70 dark:hover:border-indigo-300/30 dark:hover:shadow-[0_22px_48px_rgba(0,0,0,0.4)]"
    onClick={onClick}
  >
    <span className="absolute inset-x-0 top-0 h-1 origin-left scale-x-0 bg-gradient-to-r from-indigo-500 via-violet-500 to-sky-400 transition-transform duration-300 ease-out group-hover:scale-x-100 group-focus-visible:scale-x-100" />
    <h2 className="flex items-center gap-2 text-2xl font-semibold text-indigo-700 dark:text-indigo-200">
      {icon}
      {title}
    </h2>
    <p className="text-slate-600 dark:text-slate-300">{description}</p>
  </button>
);

export default SectionTile;
